<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <el-row>
          <el-col :span="3">
            <!-- <el-select
                style="width: 95%;"
                size="medium"
                v-model="carBrandSelect"
                placeholder="品牌"
                @change="carBrandSelectChange"
                clearable
                @focus="searchCarBrand"
              >
              <el-option v-for="brand in brandOptions" :label="category.label" :value="category.carBrandId" :key="brand.carBrandId"></el-option>
            </el-select> -->

            <el-select style="width: 95%;" v-model="carBrandSelect" @change="carBrandSelectChange" clearable
              size="medium" @focus="searchCarBrand" placeholder="品牌筛选">
              <el-option label="全部" value="all" key="all"></el-option>
              <el-option v-for="brand in brandOptions" :label="brand.carBrandName" :value="brand.carBrandId"
                :key="brand.carBrandId">
              </el-option>

            </el-select>
          </el-col>
          <el-col :span="5">
            <div>
              <el-input size="medium" placeholder="请输入搜索关键字" v-model="world" style="width: 97%;" clearable>
              </el-input>
            </div>
          </el-col>
          <el-col :span="9">
            <div>
              <el-date-picker v-model="createTime" size="medium" type="datetimerange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :editable="true" :clearable="true">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="2">
            <div>
              <el-button type="primary" size="medium" icon="el-icon-search" @click="searchCarCategory">搜索</el-button>
            </div>
          </el-col>
          <el-col :span="2">&nbsp;</el-col>
          <el-col :span="2">
            <el-button type="success" size="medium" @click="openCarAddDialog(true, true, null)"
              v-if="checkButtonPermission('car:manage:category:add')">新增车型</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="carCategoryName" label="车型名"></el-table-column>
          <!--<el-table-column prop="label" label="车型排序"></el-table-column>-->
          <el-table-column prop="carCategoryImage" label="车型图片">
            <template slot-scope="scope">
              <img :src="scope.row.carCategoryImage" min-width="32" height="32" />
            </template>
          </el-table-column>
          <el-table-column prop="carBrand.carBrandName" label="车品牌"></el-table-column>
          <el-table-column prop="createTime" label="时间" width="320"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="openCarAddDialog(true, false, scope.row)" type="success" size="mini"
                v-if="checkButtonPermission('car:manage:category:edit')">编辑
              </el-button>
              <el-button @click="deleteCarCategory(scope.row.carCategoryId)" type="danger" size="mini"
                v-if="checkButtonPermission('car:manage:category:delete')">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 18px 0px; float: right;">
          <el-pagination background @current-change="currentPageChange" @size-change="pageSizeChange"
            :current-page="currentPage" :page-sizes="[5, 10, 20, 50, 100]" :page-size="pageSize" :page-count="totalPage"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog :title="addCarCategoryDialogTitle + '车型'" :visible.sync="addCarCategoryDialogVisible" :modal="false"
      :close-on-click-modal="false" @closed="resetForm('carCategoryForm')" @open="openDialogEvent(addFlag)">
      <el-form :model="carCategoryForm" ref="carCategoryForm" :rules="carCategoryRules" label-width="120px"
        size="medium" style="padding: 0 10%;">
        <el-form-item label="车型名" prop="carCategoryName">
          <el-input v-model="carCategoryForm.carCategoryName" clearable></el-input>
        </el-form-item>
        <!--<el-form-item label="排序" prop="label">
          <el-input v-model="carCategoryForm.label" clearable></el-input>
        </el-form-item>-->
        <el-form-item label="车型图片" prop="carCategoryImage">
          <el-upload :limit="1" :file-list="fileList" :on-success="uploadCategoryImageSuccess"
            :action="this.env.env.uploadUrl" list-type="picture-card" :on-preview="uploadPreviewHandler"
            :on-remove="uploadRemoveHandler">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="车品牌" prop="carCategoryImage">
          <el-select v-model="dialogSelect" @change="carCategoryChange">
            <el-option v-for="brand in dialogBrands" :label="brand.carBrandName" :value="brand.carBrandId"
              :key="brand.carBrandId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item size="large">
          <el-button
            @click="addCarCategoryDialogVisible = false">&nbsp;&nbsp;&nbsp;取&nbsp;&nbsp;消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button type="primary"
            @click="submitCarBrandForm('carCategoryForm')">&nbsp;&nbsp;&nbsp;确&nbsp;&nbsp;定&nbsp;&nbsp;&nbsp;</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="uploadDialogVisible">
      <img width="100%" :src="carCategoryForm.carCategoryImage" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { reqCode, dialogAction } from '@/common/const';
export default {
  name: "carCategoryList",
  data() {
    return {
      world: '',
      createTime: [],
      tableData: [
        {
          carBrandId: "123",
          carCategoryId: "aaaaahhhhhccccclllkklsdflasdjflsdfalsdjf",
          carCategoryImage: "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1583475651228&di=00624c7624e0e700304f1be82294b659&imgtype=0&src=http%3A%2F%2Fimg.juimg.com%2Ftuku%2Fyulantu%2F121209%2F267868-12120919111323.jpg",
          carCategoryName: "测试-五菱宏光",
          createTime: "2020-03-06 21:00:00",
          carBrand: {
            carBrandName: '奥迪'
          }
        },
      ],
      addCarCategoryDialogVisible: false,
      addCarCategoryDialogTitle: '新增',
      currentPage: 1,
      pageSize: 20,
      totalPage: 100,
      total: 100000,
      carCategoryForm: {
        carCategoryName: '',
        carCategoryImage: '',
        carBrand: {
          carBrandName: '奥迪'
        }
      },
      carCategoryRules: {
        carCategoryName: [{ required: true, message: '车型名不能为空', trigger: 'blur' }],
      },
      uploadDialogVisible: false,
      addFlag: true,
      dialogSelect: '',
      dialogBrands: [],
      fileList: [],
      carBrandSelectVal: '',
      carBrandSelect: '',
      brandOptions: []
    }
  },
  created() {
    this.searchCarCategory();
  },
  methods: {
    searchCarBrand() {
      this.$http.post('/api/car/brand/all', {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        console.log(data)
        if (data.code === "success") {
          this.brandOptions = data.resultList;
        }
      }).catch(e => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + e, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    carBrandSelectChange(val) {
      this.carBrandSelectVal = val;
    },
    uploadCategoryImageSuccess(resp, file, list) {
      if (reqCode.SUCCESS == resp.code) {
        this.carCategoryForm.carCategoryImage = resp.data;
      } else {
        this.$message({
          message: '上传文件失败：' + resp.message,
          type: 'error'
        });
      }
    },
    openCarAddDialog(addCarCategoryDialogVisible, addFlag, data) {
      this.addFlag = addFlag;
      if (addFlag == false) {
        this.addCarCategoryDialogTitle = '编辑';
        let tmp = {};
        Object.assign(tmp, data);
        this.dialogSelect = tmp.carBrandId;
        this.carCategoryForm = tmp;
        let imgObj = new Object();
        imgObj.url = tmp.carCategoryImage;
        this.fileList.push(imgObj);
      } else {
        this.addCarCategoryDialogTitle = '新增';
      }
      this.addCarCategoryDialogVisible = addCarCategoryDialogVisible;
    },
    searchCarCategory() {
      let reqParam = {
        currentPage: this.currentPage,
        size: this.pageSize,
        startCreateTime: this.createTime[0],
        endCreateTime: this.createTime[1],
        carCategoryName: this.world,
      };

      if (this.carBrandSelectVal != '' && this.carBrandSelectVal != 'all') {
        reqParam.carBrandId = this.carBrandSelectVal;
      }

      this.$http.post('/api/car/category/list', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        console.log(resp);
        let pageInfo = resp.data.pageInfo;
        this.tableData = pageInfo.list;
        this.pageSize = pageInfo.pageSize;
        this.total = pageInfo.total;
        this.totalPage = pageInfo.pages;
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    addCarCategory(formName, reqParam) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post('/api/car/category/add', reqParam, {
            headers: {
              accessToken: sessionStorage.getItem('accessToken')
            }
          }).then(resp => {
            this.$message({
              message: '新增车型成功',
              type: 'success'
            });
            this.addCarCategoryDialogVisible = false;
            this.resetForm('carCategoryForm');
            this.searchCarCategory();
          }).catch(e => {

          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    editCarCategory(formName, reqParam) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post('/api/car/category/update', reqParam, {
            headers: {
              accessToken: sessionStorage.getItem('accessToken')
            }
          }).then(resp => {
            let data = resp.data;
            if (data.code === "success") {
              this.$message({
                message: '编辑车型成功',
                type: 'success'
              });
              this.addCarCategoryDialogVisible = false;
              this.searchCarCategory();
            } else {
              this.$alert('' + data.message, '温馨提示', {
                confirmButtonText: '确定'
              });
            }
          }).catch(e => {

          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    deleteCarCategory(carCategoryId) {
      this.$http.post('/api/car/category/delete?carCategoryId=' + carCategoryId, {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        if (data.code === "success") {
          this.$message({
            message: '删除品车型成功',
            type: 'success'
          });
          this.addCarCategoryDialogVisible = false;
          this.searchCarCategory();
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(e => {

      })
    },
    currentPageChange(val) {
      this.currentPage = val;
      // alert("currentPage发生改变");
      this.searchCarCategory();
    },
    pageSizeChange(val) {
      this.pageSize = val;
      // alert("pageSize发生改变");
      this.searchCarCategory();
    },
    submitCarBrandForm(formName) {
      let reqParam = {
        carCategoryName: this.carCategoryForm.carCategoryName,
        carCategoryImage: this.carCategoryForm.carCategoryImage,
        carBrandId: this.dialogSelect,
        // label: this.carCategoryForm.label,
      };

      if (this.addFlag) {
        this.addCarCategory(formName, reqParam);
      }

      else {
        reqParam.carCategoryId = this.carCategoryForm.carCategoryId;
        this.editCarCategory(formName, reqParam);
      }
    },
    resetForm(formName) {
      this.carCategoryForm = {};
      this.fileList = [];
      this.$refs[formName].resetFields();
    },
    uploadRemoveHandler() {

    },
    uploadPreviewHandler(file) {
      this.carBrandForm.carCategoryImage = file.url;
      this.uploadDialogVisible = true;
    },
    carCategoryChange() {

    },
    openDialogEvent(addFlag) {
      if (addFlag) {
        this.dialogSelect = '';
      }
      this.$http.post('/api/car/brand/all', {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        if (data.code === "success") {
          this.dialogBrands = data.resultList;
        }
      }).catch(e => {

      })
    },
    checkButtonPermission(perms) {
      let menuPermsList = sessionStorage.getItem("menuPermsList");
      if (menuPermsList.indexOf(perms) != -1) {
        return true
      } else {
        return false;
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/car/category/carCategoryList.vue